<template>
    <b-modal v-model="vModel.onBehalfDecisionCheck.ShowOnbehalfNationalityPopup" id="modal-center" class="modal-validation" size="md" no-close-on-backdrop='true'
        no-close-on-esc='true' centered hide-header hide-footer>
        <template v-slot:default="">
            <p>Are you helping someone send money?
            </p>
            <br />
            <div class="popup-onbehalf-button-wrapper"><span>
                <b-button class="button-left"  variant="danger" @click="handleNo">NO</b-button>
                <b-button class="button-right"  variant="success" @click="handleYes">YES</b-button>
                </span>
            </div>
        </template>
    </b-modal>
</template>
<script>
    import CommonService from "../services/common";
    export default {
        name: "OnBehalfPopupDialog",
        props: ["vModel"],
        methods: {
            handleYes: function (evt) {                              
                this.vModel.onBehalfDecisionCheck.ShowOnbehalfNationalityPopup = false;
                this.vModel.onBehalfDecisionCheck.ShowOnbehalfList = true;
                console.log(this.vModel);

                
            },

            handleNo: function (evt) {                              
                this.vModel.onBehalfDecisionCheck.ShowOnbehalfNationalityPopup = false;
                this.vModel.isOnBehalfTransaction = false;
                
            }
        }
    };
</script>
